import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { validateEnvironment } from './config/environment';

// Validate environment configuration before starting the app
try {
  validateEnvironment();
} catch (error) {
  console.error('❌ Environment validation failed:', error);
  // In production, you might want to show a user-friendly error page
  // For now, we'll still render the app but log the error
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
